import React from "react";

const ShimmerCard=()=>{
    return <div className="u-card">
        <div className="u-image"></div>
        <div className="total">
        <h5 className="u-title"> </h5>
        <h4 className="u-channel"> </h4>
        <h6 className="u-views"> </h6>
        </div>
        
    </div>
    
}
const Shimmer=()=>{
    return <div className="v-container">
      <ShimmerCard/>
      <ShimmerCard/>
      <ShimmerCard/>
      <ShimmerCard/>
      <ShimmerCard/>
      <ShimmerCard/>
      <ShimmerCard/>
      <ShimmerCard/>
      <ShimmerCard/>
      <ShimmerCard/>
      <ShimmerCard/>
      <ShimmerCard/>
      <ShimmerCard/>
      <ShimmerCard/>
      <ShimmerCard/>
      <ShimmerCard/>
      <ShimmerCard/>
      <ShimmerCard/>
      <ShimmerCard/>
      <ShimmerCard/>
      <ShimmerCard/>
      <ShimmerCard/>
      <ShimmerCard/>
      <ShimmerCard/>
      <ShimmerCard/>
      <ShimmerCard/>
      <ShimmerCard/>
      <ShimmerCard/>
      <ShimmerCard/>
      <ShimmerCard/>
      <ShimmerCard/>
      <ShimmerCard/>
      <ShimmerCard/>
      <ShimmerCard/>
      <ShimmerCard/>
      <ShimmerCard/>
      <ShimmerCard/>
      <ShimmerCard/>
      <ShimmerCard/>
      <ShimmerCard/>
      <ShimmerCard/>
      <ShimmerCard/>
      <ShimmerCard/>
      <ShimmerCard/>
      <ShimmerCard/>
    </div>
}
export default Shimmer;